export class InspirationGallery {
    private static instance: InspirationGallery;
    public insGalleryDomPresent = (document.querySelector('.gallery-page-section') as HTMLElement)?.classList?.contains('inspiration-gallery');
    public loadMoreButton:any =document.querySelector('.gallery-page-main-inspiration .cta-wrapper .btn') as HTMLElement;
    public ImageCategory:any =  (document.getElementById('all') as HTMLInputElement)?.value?.toLocaleLowerCase();
    private cleanupController: (() => void) | null = null;
       static getInstance(): InspirationGallery {
        if (!InspirationGallery.instance) {
            InspirationGallery.instance = new InspirationGallery();
        }
        return InspirationGallery.instance;
    }
    constructor(){
       if(this.insGalleryDomPresent){
        const insCategory:any = document.querySelectorAll('.category-radio')
        insCategory?.forEach((item:any)=>{
            item?.addEventListener('change', ()=>{
                this.getImageTabType(item.getAttribute('id')?.toLocaleLowerCase())
            })
        })
        this.updateCategorySelection();
        this.formatDropdownOptions();     
        this.loadMore();   
      }
    }
    public getImageTabType(imageCat:any){
        this.ImageCategory = '';
        this.ImageCategory = imageCat;
        if (this.loadMoreButton) { 
            this.loadMoreButton.style.display = 'flex';
        }
        const imageList:any = document.querySelectorAll('.gallery-page-main-inspiration .photo-card-list .photo-card-item');
        const allTab = (document.getElementById('all') as HTMLInputElement)?.value;
        if(imageList.length>0){
            if(imageCat !== allTab?.toLocaleLowerCase()){
            imageList.forEach((insImagesLi:any)=>{
                if(insImagesLi?.getAttribute('category-id')?.toLocaleLowerCase() === imageCat){
                    insImagesLi?.classList?.remove('hidden');
                }else {
                    insImagesLi?.classList?.add('hidden');
                }
            })
        }else {
            const firstFiveItems = Array.from(imageList).slice(0, 5);
            const afterFiveItems = Array.from(imageList).slice(firstFiveItems.length, imageList.length)
            firstFiveItems?.forEach((insImagesLi:any)=>{
                insImagesLi?.classList?.remove('hidden');
            })
            afterFiveItems?.forEach((insImagesLi:any)=>{
                insImagesLi?.classList?.add('hidden');
            })
        }
        }
    }

    public loadMore(){
        const allTab = (document.getElementById('all') as HTMLInputElement)?.value ?? '';
        this.loadMoreButton?.addEventListener('click', (e:any)=> {
            e.preventDefault();
            const hiddenItems = (this.ImageCategory === allTab.toLocaleLowerCase()) ? document.querySelectorAll('.photo-card-item.hidden') : document.querySelectorAll(`li.photo-card-item.hidden[category-id="${this.ImageCategory}"]`);
            const initialHiddenItemCount = hiddenItems.length;
            const nextHiddenItems = Array.from(hiddenItems).slice(0, 6);
            nextHiddenItems?.forEach(item => {
           item.classList.remove('hidden');
           });
          const remainingHiddenItemCount = initialHiddenItemCount - nextHiddenItems.length;
       if (remainingHiddenItemCount === 0) {
           this.loadMoreButton.style.display = 'none';
        }
      });
    }
   
public updateCategorySelection() {
    const categoryDropdown = document.querySelector('.gallery-page-section.inspiration-gallery .select-basic') as HTMLSelectElement;
    const imageList = document.querySelectorAll('.gallery-page-main-inspiration .photo-card-list .photo-card-item');

    const controller = new AbortController();
    const { signal } = controller;

    categoryDropdown?.addEventListener('change', () => {
        const selectedCategory = categoryDropdown?.value?.trim() ?? ''; // Added null safety check and trim

        if (selectedCategory.toLowerCase() === 'all') {
            imageList?.forEach((item) => {

                (item as HTMLElement)?.classList?.remove('hidden');
            });
        } else {
            imageList?.forEach((item) => {
                const categoryId = (item as HTMLElement).getAttribute('category-id') ?? '';
                if (categoryId === selectedCategory) {
                    (item as HTMLElement)?.classList?.remove('hidden');
                } else {
                    (item as HTMLElement)?.classList?.add('hidden');
                }
            });
        }
    }, { signal });

    this.cleanupController = () => controller.abort();
}

public destroy() {
    if (this.cleanupController) {
        this.cleanupController();
        this.cleanupController = null;
    }
}

public formatDropdownOptions() {
    const categoryDropdown = document.querySelector('.gallery-page-section.inspiration-gallery .select-basic') as HTMLSelectElement;

    if (categoryDropdown && categoryDropdown?.options?.length > 0) {
        const uniqueOptions = new Set<string>();

        Array.from(categoryDropdown.options).forEach(option => {
            const value = option.value.trim();
            if (value && !uniqueOptions.has(value)) {
                uniqueOptions.add(value);
            }
        });

        categoryDropdown.options.length = 0; // Clear existing options

        uniqueOptions.forEach(value => {
            const newOption = document.createElement('option');
            newOption.value = value;
            newOption.textContent = value;
            categoryDropdown.appendChild(newOption);
        });
    }
}

}

// Initialize the Inspiration gallery class when the DOM is ready
if (!(globalThis as any).__InspirationGalleryListenerAdded) {
    (globalThis as any).__InspirationGalleryListenerAdded = true;
    document.addEventListener('DOMContentLoaded', () => {
        const inspirationGallerySection = document.querySelector(".gallery-page-section.inspiration-gallery") as HTMLElement;
        // Prevent multiple instances
        if (!inspirationGallerySection || (globalThis as any).__InspirationGalleryInitialized) return;
        (globalThis as any).__InspirationGalleryInitialized = true;
        InspirationGallery.getInstance();
    });
}